export const theme = {
  primary: "#61dafb",
};
